import { FunctionComponent, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import CatalogOnPage from "../../components/CatalogPdfRender/CatalogOnPage";
import Loading from "../../components/common/Loading";
import { ManufacturingCostService } from "../../services/manufacturingCost";
import { ProductServices } from "../../services/products";
import { useAsync } from "../../utils/hooks/useAsync";

const Catalog: FunctionComponent = ({}) => {
  const { run, isLoading, isSuccess } = useAsync();
  const [products, setProducts] = useState<CatalogProduct[]>();
  const [manufacturingCost, setmanufacturingCost] =
    useState<ManufacturingCost[]>();
  const { catalog, solid } = useParams();
  useEffect(() => {
    catalog == "all"
      ? run(ProductServices.getProductsCatalog({})).then((data: any) => {
          setProducts(data?.data || []);
        })
      : run(ProductServices.getProductsCatalog({ department: catalog })).then(
          (data: any) => {
            setProducts(
              (catalog == "chain" || "brazalete") && solid == "true"
                ? data?.data.filter((el: any) => el.category.includes("solid"))
                : data?.data.filter(
                    (el: any) => !el.category.includes("solid")
                  ) || []
            );
          }
        );
    run(
      ManufacturingCostService.getManufacturingCost().then((data: any) => {
        setmanufacturingCost(data.data);
      })
    );
  }, []);
  return (
    <>
      {isLoading && <Loading></Loading>}
      {products && catalog && products.length > 0 && (
        <CatalogOnPage
          products={products}
          catalog={catalog}
          manufacturingCost={manufacturingCost}
        />
      )}
    </>
  );
};

export default Catalog;
